import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import RLogo from '../img/rls_logo.png';
import * as sessionActions from 'actions/session';


class LoginPage extends Component {
	static propTypes = {
		history: PropTypes.object.isRequired
	}

	state = {
		username: '',
		password: ''
	}

	componentDidMount() {
		if (this.props.showHeader) {
			this.props.onShowHideHeader(false);
		}
		if (this.props.showFooter) {
			this.props.onShowHideFooter(false);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.session.isAuthenticated && nextProps.session.user !== undefined && nextProps.session.user !== null) {
			this.props.history.push('/home');
		}
	}

	handleInputChange = event => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		this.setState({
			[name]: value,
			errorMsg: ""
		});
	}

	handleSubmit = event => {
		event.preventDefault();

		var errMsg = "";
		if (!this.state.username || this.state.username === "") {
			errMsg += "Username is required. ";
		}
		if (!this.state.password || this.state.password === "") {
			errMsg += "Password is required. ";
		}

		if (errMsg === "") {
			this.props.sessionActions.login({
				Username: this.state.username,
				Password: this.state.password
			});
		}
		else {
			this.setState({ errorMsg: errMsg });
		}
	}

	render() {

		const { session } = this.props;

		return (
			<div>
				<div style={{ padding: 24 }}>

					<Grid container spacing={24}>
						<Grid item xs={12}>

							<Grid container justify="center" alignItems="center" className="container" style={{ minHeight: "400px" }}>
								<Grid item>

									<div style={{ textAlign: "center" }}>
										<img src={RLogo} alt="Rebny" style={{ width: "150px", marginBottom: "20px" }} />
									</div>

									<Paper style={{ padding: "30px", width: "300px" }}>

										<div>
											<form>
												<div>
													{this.state.errorMsg && this.state.errorMsg !== "" &&
														<Typography align="center" color="error" gutterBottom>
															{this.state.errorMsg}
														</Typography>
													}
													{session && session.error && session.error !== "" &&
														<Typography align="center" color="error" gutterBottom>
															{session.error}
														</Typography>
													}
													<div>
														<span></span>
														<div>
															<TextField
																required
																fullWidth
																id="user"
																name="username"
																label="Username"
																margin="normal"
																value={this.state.username}
																onChange={this.handleInputChange}
															/>
														</div>
													</div>
													<div>
														<span></span>
														<div>
															<TextField
																required
																fullWidth
																id="pass"
																name="password"
																label="Password"
																margin="normal"
																type="password"
																value={this.state.password}
																onChange={this.handleInputChange}
															/>
														</div>
													</div>
													<div style={{ height: "30px" }}></div>
													<div>
														<div style={{ width: "100%", textAlign: "center" }}>
															<Button variant="raised" color="primary" onClick={this.handleSubmit}>Login</Button>
														</div>
													</div>
												</div>
											</form>
										</div>

									</Paper>
								</Grid>
							</Grid>

						</Grid>
					</Grid>

				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => ({
	session: state.session
});

const mapDispatchToProps = dispatch => ({
	sessionActions: bindActionCreators(sessionActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
